module.exports = __webpack_public_path__ + "media/images/image_etrac-1ecc86e3937d6587a58e4c1ae6ad908c.png";